import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://imwdnfbqbkhrjonothzr.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imltd2RuZmJxYmtocmpvbm90aHpyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY3NDA3OTAsImV4cCI6MjA5MjMxNjc5MH0.R2VUTdUiC8OH2cLBNgGKsosrgi1utLklg6H3UTbogOo';

export const supabase = createClient(supabaseUrl, supabaseKey);